import React from 'react'
import Image from 'next/legacy/image'
import {useTranslation} from 'next-i18next'
import {Box, Flex, HStack, Text} from '@chakra-ui/react'
import PriceText from '_app/components/PriceText'
import {SimpleCartItem} from '_app/graphql/generated/graphql'
import SpecialPrice from '_app/components/SpecialPrice'
import {CustomizableEngraveCartItem, PaidOptions} from './PaidOptions'

interface JewelryBucketProps {
    jewelry?: CustomizableEngraveCartItem[];
}

export const JewelryItems = ({jewelry = []}: JewelryBucketProps) => {
    const {t} = useTranslation()

    return (
        <Box
            maxHeight={{base: '20.25rem', lg: 'unset'}}
            overflow={jewelry?.length > 3 ? 'scroll' : 'none'}
            css={{
                '&::-webkit-scrollbar': {
                    display: 'none',
                },
            }}
        >
            {(jewelry ?? []).map((cartItem, index) => {
                const {product, quantity, prices} = cartItem || {}
                const {id, image, name, price_range} = product || {}
                const price = prices?.price || price_range?.minimum_price.final_price
                const isGift = prices?.price?.value === 0
                return (
                    <Flex key={index} pb={6}>
                        <Box bg="main" width="5.375rem" height="5.375rem" mr={4}>
                            <Image
                                src={image?.url || ''}
                                width="86"
                                height="86"
                                alt={image?.label || ''}
                            />
                        </Box>

                        <Flex
                            flexDirection="column"
                            display={{base: 'flex', md: 'none'}}
                            flexGrow={1}
                            justifyContent="space-between"
                        >
                            {!!isGift && (
                                <Flex w="100%" mb={2}>
                                    <Text
                                        textStyle="productOption"
                                        bgColor="#fcca9d"
                                        p="0.25rem 0.75rem"
                                    >
                                        {t('GIFT')}
                                    </Text>
                                </Flex>
                            )}
                            <Text className="truncate-text" fontWeight={300} mb="1.125rem" flexGrow={1}>
                                {name}
                            </Text>
                            {!isGift && price && (
                                <Flex justify="space-between" align="flex-end" flexGrow={1}>
                                    <PriceText
                                        amount={price}
                                        floating
                                        minimumFractionDigits={2}
                                    />
                                    <Text>{quantity}szt.</Text>
                                </Flex>
                            )}
                            <PaidOptions cartItem={cartItem}/>
                        </Flex>

                        <Flex
                            height="auto"
                            display={{base: 'none', md: 'flex'}}
                            flexDirection="column"
                            flexGrow={1}
                        >
                            {!!isGift && (
                                <Flex w="100%" mb={2}>
                                    <Text
                                        textStyle="productOption"
                                        bgColor="#fcca9d"
                                        p="0.25rem 0.75rem"
                                    >
                                        {t('GIFT')}
                                    </Text>
                                </Flex>
                            )}
                            <HStack
                                spacing="1.875rem"
                                alignItems="flex-start"
                                flexGrow={1}
                                justifyContent="space-between"
                            >
                                <Text
                                    maxWidth={isGift === false ? '11.875rem' : '16.25rem'}
                                    fontWeight={300}
                                    mb="1.125rem"
                                    flexGrow={1}
                                >
                                    <Text className="truncate-text" fontWeight={300} mb="1.125rem" flexGrow={1}>
                                        {name}
                                    </Text>
                                </Text>
                                {!isGift && (
                                    <SpecialPrice
                                        isGift={isGift}
                                        item={cartItem as SimpleCartItem}
                                    />
                                )}
                            </HStack>
                            {!isGift && (
                                <Text fontWeight={300} flexGrow={1}>
                                    {quantity} {t('PCS')}.
                                </Text>
                            )}
                            <PaidOptions cartItem={cartItem} isDrawerMode/>
                        </Flex>
                    </Flex>
                )
            })}
        </Box>
    )
}
